import { FormValidationRule } from "../types";

export const validCharsRegex = new RegExp(
    "^[a-zA-Z0-9\\/\\-\\'\\sdÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöüçÇßØøÅåÆæÞþÐð,\\(\\)\\.\\:]*$"
);
const validCharacters: FormValidationRule = (c, v) => {
    let valid = true;
    if ((c.type === "text" || c.type === "textarea") && v && !c.field_regex_validation) {
        valid = validCharsRegex.test(v);
    }
    return [valid, c.errorMessage || "You've entered an invalid character."];
};

export default validCharacters;
